import { Flex } from '../UI/Flex/Flex';
import * as style from './ChatMessage.module.less';

import classNames from 'classnames';
import { observer } from 'mobx-react';
import { LogoBird } from '../Header/Logo';

interface ChatMessagesStringProps {
    msgString: string;
    hideLogo?: boolean;
}

export const ChatMessageString = observer((p: ChatMessagesStringProps) => {
    const clssses = classNames(style.chatmessage, 'fade-in');

    return (
        <>
            <Flex className={clssses} direction="row">
                <div
                    style={{
                        marginRight: '16px',
                        flexShrink: 0,
                        alignSelf: 'flex-start',
                        visibility: p.hideLogo === true ? 'hidden' : 'visible'
                    }}
                >
                    <LogoBird />
                </div>
                <div className={style.aiContent}>{p.msgString}</div>
            </Flex>
            {/* {files_references} */}
        </>
    );
});
